import { Component, OnInit } from '@angular/core';
import { StuDataService } from '../services/stu-data.service';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css'],
  providers: [StuDataService]
})
export class AboutUsComponent implements OnInit {
  dataObj:any;
  stuName:any;
  stuDesignation:any;
  newDataObj:any;
  constructor(private _stuData:StuDataService) { 
    this.dataObj = this._stuData.getData();
  }

  ngOnInit() {
    console.log('about us page loaded');
  }

  saveData() {
    this.newDataObj = {
      name: this.stuName,
      designation: this.stuDesignation
    };
    this._stuData.setData(this.newDataObj);
    this.stuName='';
    this.stuDesignation='';
  }

}
